module.exports = __webpack_public_path__ + "img/94.79ba0b4e.webp";